var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineLockCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11v-1c0-1.46-.36-2.25-2.25-2.25-1.89 0-2.25.79-2.25 2.25v1c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1c0-.93 0-3.75 3.75-3.75s3.75 2.82 3.75 3.75v1c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.65 14c0-.74.61-1.35 1.35-1.35.74 0 1.35.61 1.35 1.35 0 .74-.61 1.35-1.35 1.35-.74 0-1.35-.61-1.35-1.35zm1.2 0c0 .17.3.17.3 0 0-.08-.07-.15-.15-.15-.08 0-.15.07-.15.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.75c-2.4 0-3.25-.85-3.25-3.25v-1c0-2.4.85-3.25 3.25-3.25h5c2.4 0 3.25.85 3.25 3.25v1c0 2.4-.85 3.25-3.25 3.25h-5zM7.75 13.5v1c0 1.59.16 1.75 1.75 1.75h5c1.59 0 1.75-.16 1.75-1.75v-1c0-1.59-.16-1.75-1.75-1.75h-5c-1.59 0-1.75.16-1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12 17.93 22.75 12 22.75 1.25 17.93 1.25 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineLockCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-lock-circle.b321ff3525967c4243b621f5e4a22628.svg";
export { ForwardRef as ReactComponent };